// The "Talent, not a client" tag — a project whose chat is a talent pitching
// their services rather than a business buying them.
//
// A TAG, not an alert, and the distinction is the point. The alert cell next to
// it answers "does someone need to do something here"; this answers "what is
// this project", which is why it is rendered beside the project's NAME and why
// the backend derives it from the whole flag history rather than the open set
// (`attention.PROJECT_FLAG_COLUMNS_SQL`). Resolving the alert clears the work,
// not the fact.
//
// Worth its own component rather than three inline Badges: the label is the
// whole content, and three copies of a label drift.
import { Badge } from "@recruiter/shared";

/** Renders nothing when the project is an ordinary client one, so a caller can
 *  drop it in unconditionally instead of repeating the guard. */
export function SellerIntentTag({ sellerIntent }: { sellerIntent: boolean | undefined }) {
  if (!sellerIntent) return null;
  return (
    <Badge tone="danger" size="sm">
      Talent, not a client
    </Badge>
  );
}
